/*
 * @Author: liu_ning liu_ning@leapmotor.com
 * @Date: 2024-07-30 15:24:13
 * @LastEditors: liu_ning liu_ning@leapmotor.com
 * @LastEditTime: 2024-08-15 13:30:57
 * @FilePath: \LP_LeapCloud_Appweb\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import ajax from "@/request";
import "react-vant/es/styles";
// import VConsole from 'vconsole'
import { openMsg, closeMsg } from "@/utils/vehicle";
const service = ajax();
/**
 * 由于要提供给车机端调用，所以绑定在window全局对象上。同时内容组件使用window.messageDetailUpload调用
 */
window.messageDetailUpload = (
    vin,
    messageId,
    operateType,
    operateTime,
    fn,
    carType,
    isMessageDetail,
) => {
    // console.log('端回调参数', vin, messageId, operateType, operateTime, fn)
    service
        .get(
            "/apiappweb/proxy/messageProvide/messageDetailUpload?messageCenter",
            {
                headers: {
                    deviceId: vin,
                    model: carType,
                    channel: "IVI", // ivi 车机 icu 仪表
                    timestamp: Date.now(),
                },
                params: {
                    vin,
                    messageId,
                    operateType,
                    operateTime,
                },
            },
        )
        .then((res) => {
            if (res.success) {
                if (isMessageDetail) {
                    return;
                } else {
                    if (operateType === 1) {
                        openMsg(1);
                        return true;
                    } else {
                        closeMsg();
                        return false;
                    }
                }
            } else {
                alert("上传明细失败了");
            }
        });
};
// localStorage.setItem('vConsole_switch_x', 800)
// localStorage.setItem('vConsole_switch_y', 700)
// new VConsole()
window.$change_theme = function (theme) {
    sessionStorage.setItem("$theme", theme);
};
// 暂停视频播放
window.$video_pause = function () {
    let video = document.getElementById("video");
    if (video) {
        video.pause();
    }
};

ReactDOM.render(<App />, document.querySelector("#app"));
